/**
 * Calculates a scaled-down width and height so that the image fits 
 * within the given maximum boundaries, preserving its aspect ratio.
 * 
 * @param {number} naturalWidth 
 * @param {number} naturalHeight 
 * @param {number} maxWidth 
 * @param {number} maxHeight 
 * @param {number} [margin=0.8] Fraction of max dimensions to occupy
 * @returns {{ width?: number, height?: number }}
 */
export function calcFitImageSize(naturalWidth, naturalHeight, maxWidth, maxHeight, margin = 0.8) {
    if (!naturalWidth || !naturalHeight) return {}

    let w = naturalWidth
    let h = naturalHeight
    
    if (maxWidth && maxHeight) {
        const maxW = maxWidth * margin
        const maxH = maxHeight * margin

        if (w > maxW || h > maxH) {
            const scale = Math.min(maxW / w, maxH / h)
            w = Math.round(w * scale)
            h = Math.round(h * scale)
        }
    }
    
    return {width: w, height: h}
}
